export default __webpack_public_path__ + "static/media/save.c43c1db0.svg";